import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { ApplicationSettingsPage, ApplicationSettingsPageUrl } from '../const'

import { Store } from '@ngrx/store'
import { RateCardMetaStructureField } from '../models'
import { ApplicationSettingConfig } from '../models/application-settings-item.model'
import { ApplicationSettingsActions } from '../store/application-settings.actions'
import { ApplicationSettingsSelectors } from '../store/application-settings.selectors'

@Component({
  selector: 'application-settings-container',
  templateUrl: './application-settings-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationSettingsContainerComponent implements OnInit {
  currentPage = ApplicationSettingsPage.SETTINGS

  isLoading$ = this.store$.select(ApplicationSettingsSelectors.selectApplicationSettingsLoading)
  settings$ = this.store$.select(ApplicationSettingsSelectors.selectGroupedApplicationSettings)
  settingsLoadingMap$ = this.store$.select(ApplicationSettingsSelectors.selectApplicationSettingsLoadingMap)

  constructor(
    private store$: Store,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.setCurrentPage()
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) this.setCurrentPage()
    })

    this.store$.dispatch(ApplicationSettingsActions.getApplicationSettings())
  }

  saveRateCardsMetaStructure(fields: RateCardMetaStructureField[]) {
    this.store$.dispatch(ApplicationSettingsActions.saveRateCardMetaStructure({ fields }))
  }

  updateApplicationSetting(setting: ApplicationSettingConfig) {
    this.store$.dispatch(ApplicationSettingsActions.updateApplicationSetting({ setting }))
  }

  clearTrafficImportCache() {
    this.store$.dispatch(ApplicationSettingsActions.clearTrafficImportCache())
  }

  private setCurrentPage() {
    this.currentPage = ApplicationSettingsPageUrl[this.route.snapshot.queryParamMap.get('subTab')]
  }

  protected readonly ApplicationSettingsPage = ApplicationSettingsPage
}
